import { useEffect } from "react";

export const useShortCut = (callback, dom = window) => {
  useEffect(()=>{
    const registShortCut = (e) => {
      if (callback) {
        callback(e.key);
      }
    }

    dom.addEventListener('keydown', registShortCut)
    return () => {
      dom.removeEventListener('keydown', registShortCut);
    }
  },[callback, dom])
};
